// downloadHttp.js
import env from '../../env.json';

const { BASE_URL_TICKET } = env;

function joinUrl(url) {
    return BASE_URL_TICKET + url;
}

class DownloadHttp {
    static async downloadFile(url, data = {}) {
        const options = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                // 'Authorization': `Bearer ${token}`
            },
        };

        // For GET requests: append data as query params
        if (data) {
            const queryParams = new URLSearchParams(data).toString();
            url += `?${queryParams}`;
        }

        try {
            console.log("Download request:", joinUrl(url), options);
            const response = await fetch(joinUrl(url), options);
            console.log("Download response:", response);
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            // Return the blob directly without JSON parsing
            const blob = await response.blob();
            return blob;
        } catch (err) {
            console.log("Download error:", err);
            throw err;
        }
    }
}

export default DownloadHttp;